
























import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {PhoneNumber} from "../../modules/models";

@Component
export default class ConfirmPhoneDialog extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: null})
    personRef!: string | null;
    @Prop({default: null})
    phone!: PhoneNumber | null;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }
    get hint() {
        if(this.phone != null) {
            return `Kode mottatt på SMS til ${this.phone.splitformat()}`;
        } else {
            return "";
        }
    }

    code: number | null = null;
    working = false;

    showResendSnack = false;

    showSnackTxt: string | null = null;
    get showSnack() {
        return this.showSnackTxt != null;
    }
    set showSnack(v: boolean) {
        if(!v){
            this.showSnackTxt = null;
        }
    }

    async confirm() {
        try {
            this.working = true;
            if(this.phone != null && this.code != null) {
                const msg = await this.api.confirmPendingPhone(this.phone, Number(this.code));
                if(msg != null && msg.num == 36) {
                    this.showResendSnack = true;

                } else if(msg != null){
                    if(msg.num == 34) {
                        this.code = null;
                        this.$emit("confirmed", msg);
                        this.close();
                    } else {
                        this.showSnackTxt = msg.msg;
                    }
                } else {
                    this.close();
                }

            } else {
                throw new Error("phone/code not set");
            }
        } catch(err) {
            this.emitError(err);
        } finally {
            this.working = false;
        }
    }

    async sendNewCode() {
        try {
            if(this.personRef != null && this.phone != null) {
                this.working = true;
                this.code = null;
                this.showResendSnack = false;
                const msg = await this.api.resendPendingPhoneSecret(this.personRef, this.phone);
                if (msg != null) {
                    this.showSnackTxt = msg.msg;
                }
            } else {
                throw new Error("personRef/phone not set");
            }
        } catch (err) {
            this.emitError(err);
        } finally {
            this.working = false;
        }
    }

    close() {
        this.opened = false;
    }

}
